import type { FC } from 'react';
import React, {useEffect, useState} from 'react';
import type { NodeProps } from '../../types';
import { MirrorNodeType } from './types';
// @ts-ignore
import IconConnect from './IconConnect.jsx'
import cn from '@/utils/classnames';

const Colors = {
  'bg-workflow-block-bg': '#fcfcfd',
  'bg-util-colors-blue-blue-500': '#2e90fa',
  'bg-util-colors-blue-blue-100': '#d1e9ff',
  'bg-util-colors-cyan-cyan-100': '#cff9fe',
  'bg-util-colors-green-green-100': '#dcfae6',
  'bg-util-colors-yellow-yellow-100': '#fef7c3',
  'bg-util-colors-pink-pink-100': '#fce7f6',
  'bg-util-colors-violet-violet-100': '#ece9fe',
}

const Node: FC<NodeProps<MirrorNodeType>> = (props) => {
  const [showBorder, setShowBorder] = useState(false);
  const { data } = props;
  
  useEffect(() => {
    const showSelectedBorder = data.selected || data._isBundled || data._isEntering;
    setShowBorder(showSelectedBorder);
  }, [data.selected, data._isBundled, data._isEntering]);

  return (
    <div className="relative px-3 w-[100px]">
      <div  className="absolute top-0 left-0  w-full h-full -z-[1]" >
        <IconConnect fill={Colors[data.bgColor || 'bg-util-colors-blue-blue-500']} strokeWidth={ showBorder ? 4 : undefined} />
      </div>
      <div className={cn(
        'z-1000  text-center leading-[26px] pt-1 overflow-hidden text-ellipsis line-clamp-2',
        data.bgColor && data.bgColor !== 'bg-util-colors-blue-blue-500' ? 'text-black' : 'text-white'
      )}>{data?.mirrorNode?.name || <span className='text-gray-100'>请选择镜像节点</span>}</div>
    </div>
  );
};

export default React.memo(Node);
